import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Main from './component/Main';
import Capabilities from './component/pages/CapabilitiesPage';
import IndustryInsights from './component/pages/IndustryInsights';
import InsightsSection from './component/pages/InsightsSection';
import Contact from './component/pages/Contact';
import About from './component/pages/About';
import Framework from './component/pages/Framework';
import Environments from './component/pages/Environments';
import Admin from './component/pages/Admin';
import ProjectsPage from './component/pages/ProjectsPage';
import CaseStudyPage from './component/pages/CaseStudyPage';



function App() {
  return (
    <Router>
       <div className="App">
      <Routes>
          <Route
            path="/"
            element={
              <>
                <Main />
              </>
            }
          />
          <Route
            path="/capabilities"
            element={
              <>
                <Capabilities />
              </>
            }
          />
           <Route
            path="/industry"
            element={
              <>
                <IndustryInsights />
              </>
            }
          />
          <Route
            path="/industries"
            element={
              <>
                <Environments />
              </>
            }
          />
          <Route
            path="/insights"
            element={
              <>
                <InsightsSection />
              </>
            }
          />
          <Route
            path="/about"
            element={
              <>
                <About />
              </>
            }
          />
          <Route
            path="/framework"
            element={
              <>
                <Framework />
              </>
            }
          />
           <Route
            path="/contact"
            element={
              <>
                <Contact />
              </>
            }
          />
          <Route
            path="/admin"
            element={
              <>
                <Admin />
              </>
            }
          />
          <Route
            path="/projects"
            element={
              <>
                <ProjectsPage />
              </>
            }
          />
          <Route
            path="/projects/:id"
            element={
              <>
                <CaseStudyPage />
              </>
            }
          />
          
        </Routes>


    </div>
    </Router>
   
  );
}

export default App;
